import type { Bill } from '../entities/entityTypes';
import { useRefetchBillsMutationOptions } from '../entities/membership/hooks/useRefetchBillsMutationOptions';
import { requestBuilder } from '../http/RequestBuilder';

interface RejectBillUrlParams {
    membershipId: string;
    billId: string;
}

const useRejectBill = requestBuilder.mutation<
    Bill,
    undefined,
    RejectBillUrlParams
>({
    endpoint: ({ membershipId, billId }) =>
        `/api/admin/holistic/membership/${membershipId}/bill/${billId}/reject`,
    method: 'PATCH',
});

export const useRejectBillAndRefetch = (membershipId: string) => {
    const refetchBillsMutationOptions =
        useRefetchBillsMutationOptions(membershipId);

    const { mutateAsync } = useRejectBill(refetchBillsMutationOptions);

    const rejectBillAsync = async (billId: string) => {
        return await mutateAsync({
            urlParams: { membershipId, billId },
        });
    };

    return {
        rejectBillAsync,
    };
};
